<template>
  <div class="home">
    <div id="back-to-top" @click="scrollToTop">
      <div class="return-top">
        <div class="return-top-text">
          <img alt="" src="../assets/img/dulles/up.png" />
          <div class="text">回顶部</div>
        </div>
      </div>
    </div>
    <div style="width: 100%">
      <el-carousel
        ref="carousel"
        :autoplay="autoPlay"
        height="600px"
        indicator-position="outside"
      >
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <el-image
            v-if="getFileExtension(item.mainImg) !== 'mp4'"
            :src="getImageURL(item.mainImg)"
            fit="cover"
            style="width: 100%;height:100%"
          ></el-image>
          <video
            v-else
            :src="getImageURL(item.mainImg)"
            autoplay
            controls
            loop
            muted
            @play="handleVideoPlay"
            @timeupdate="handleTimeUpdate"
            style="
          width: 100%;
          height: 600px;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
        "
          >
            <source :src="getImageURL(banner)" type="video/mp4" />
          </video>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="w">
      <div class="title">定制淋浴房</div>
      <div class="content">
        <div
          v-for="(item, index) of customizedList"
          :key="index"
          class="content-details"
          @click="edit(item)"
        >
          <img :src="getImageURL(item.url)" alt="" class="img" />
          <div class="content-text">
            <div>{{ item.categoryName }}</div>
            <img alt="" class="img-logo" src="../assets/img/dulles/right.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "video.js/dist/video-js.css";
import { baseURL } from "../utils/index.js";

export default {
  name: "HelloWorld",
  components: {},
  data() {
    return {
      autoPlay: true, // 默认开启自动轮播
      customizedList: [],
      banner: "",
      bannerUrl: "",
      bannerList: [], //轮播数据
      videoEnding: false // 添加标志位，初始值为 false
    };
  },
  created() {},
  computed: {},
  mounted() {
    this.customizedShower();
    this.bannerBtn();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleVideoPlay() {
      this.autoPlay = false;
      this.videoEnding = false; // 视频开始播放时，重置标志位
    },
    handleTimeUpdate(event) {
      const video = event.target;
      const timeRemaining = video.duration - video.currentTime;

      if (timeRemaining < 0.5 && !this.videoEnding) {
        this.videoEnding = true; // 设置标志位为 true，阻止后续的切换操作
        this.autoPlay = true;
        this.$refs.carousel.next();
      }
    },
    getImageURL(image) {
      return baseURL + image;
    },
    bannerBtn() {
      const data = {
        moduleType: 1,
        deleteFlag: 2,
        usingFlag: 1
      };
      this.$http.post(`resource/list`, data).then(res => {
        if (res.data.code == "success") {
          // res.data.data.sort((a, b) => {
          //   if (a.displaySort === b.displaySort) {
          //     return new Date(b.updateTime) - new Date(a.updateTime);
          //   }
          //   return a.displaySort - b.displaySort;
          // });
          this.bannerList = res.data.data;
          this.banner = res.data.data[0].mainImg;
          this.bannerUrl = res.data.data[0].url || "";
        }
      });
    },
    // 淋浴房二级数据
    customizedShower() {
      const data = {
        categoryLevel: 2,
        pid: 2, //淋浴房ID固定要写死
        deleteFlag: 2,
        isViewAll: 2
      };
      this.$http.post(`category/list`, data).then(res => {
        if (res.data.code == "success") {
          this.customizedList = res.data.data;
        }
      });
    },
    // 定制淋浴房列表
    edit(e) {
      this.$router.push({
        name: "ShowerRoomDetail",
        query: { id: e.id, name: e.categoryName, isShower: 1 }
      });
    },
    handleScroll() {
      if (window.pageYOffset > 500) {
        document.getElementById("back-to-top").style.display = "block";
      } else {
        document.getElementById("back-to-top").style.display = "none";
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      document.getElementById("back-to-top").style.display = "none";
    },
    //获取文件扩展后缀
    getFileExtension(filename) {
      const lastDotIndex = filename.lastIndexOf(".");
      return lastDotIndex !== -1 ? filename.substring(lastDotIndex + 1) : "";
    }
  }
};
</script>

<style lang="scss" scoped>
.home {
  #back-to-top {
    display: none;
    position: fixed;
    bottom: 20px;
    right: 20px;
    padding: 10px;
    cursor: pointer;

    .return-top {
      background: #ffffff;
      width: 72px;
      height: 72px;
      border-radius: 72px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);

      .return-top-text {
        img {
          width: 32px;
        }

        .text {
          font-size: 12px;
          font-weight: bold;
        }
      }
    }
  }

  video::-webkit-media-controls {
    display: none !important;
  }

  video::-moz-media-controls {
    display: none !important;
  }

  video::-ms-media-controls {
    display: none !important;
  }

  video::-o-media-controls {
    display: none !important;
  }

  video {
    pointer-events: none;
  }

  .title {
    font-size: 32px;
    font-weight: bold;
    margin: 40px 0 24px 0;
  }

  .content {
    // display: flex;
    // justify-content: space-between;
    // align-content: center;
    // flex-wrap: wrap;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(382px, 0fr));
    column-gap: 44px;

    .content-details {
      width: 382px;
      border-radius: 10px;
      margin-bottom: 40px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);

      .img {
        width: 100%;
        // min-height: 508px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      }

      .content-text {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        color: #100d24;
        font-weight: bold;
        margin: 24px 32px 32px 32px;
      }
    }
  }
}
</style>
